
{
  "title": "Frequently asked questions",
  "questions": {
    "cities": "What cities do you serve?",
    "keywords": "What are you known for?"
  }
}
